export default __webpack_public_path__ + "static/media/icn_attention.57672d78.svg";